import { Injectable, Inject, PLATFORM_ID, DOCUMENT } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { WINDOW } from '@app/shared/utilities/window';

@Injectable({
    providedIn: 'root',
})
export class GoogleMapsLoaderService {
    private scriptLoaded = false;

    constructor(@Inject(PLATFORM_ID) private platformId: Object,
        @Inject(DOCUMENT) private documentRef: Document,
        @Inject(WINDOW) private windowRef: Window,) { }

    load(): Promise<void> {
        if (!isPlatformBrowser(this.platformId)) {
            return Promise.resolve();
        }

        // Avoid loading multiple times
        if (this.scriptLoaded || (this.windowRef as any)['google']?.maps) {
            return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
            const script = this.documentRef.createElement('script');
            script.src =
                'https://maps.googleapis.com/maps/api/js?key=AIzaSyCpvSspDOkr2F3ekbb5yC_w4baAxcLofmQ&libraries=places';
            script.async = true;
            script.defer = true;

            script.onload = () => {
                this.scriptLoaded = true;
                resolve();
            };

            script.onerror = (err) => reject(err);

            this.documentRef.head.appendChild(script);
        });
    }
}
